// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/** Every published API-key scope — the set services/api enforces (openapi-spec generator). */
export const API_SCOPES = [
  "alert-deliveries:read",
  "alert-rules:delete",
  "alert-rules:read",
  "alert-rules:write",
  "approval-policies:delete",
  "approval-policies:read",
  "approval-policies:write",
  "archival:read",
  "archival:write",
  "assistant:delete",
  "assistant:read",
  "assistant:write",
  "billing:read",
  "billing:write",
  "canonical-proposals:read",
  "canonical-proposals:write",
  "circuit-breaker-policies:delete",
  "circuit-breaker-policies:read",
  "circuit-breaker-policies:write",
  "circuit-breakers:read",
  "circuit-breakers:write",
  "cli-snippets:delete",
  "cli-snippets:read",
  "cli-snippets:write",
  "connection-environment-bindings:delete",
  "connection-environment-bindings:read",
  "connection-environment-bindings:write",
  "connections:delete",
  "connections:read",
  "connections:write",
  "events:read",
  "events:write",
  "field-authority-rules:delete",
  "field-authority-rules:read",
  "field-authority-rules:write",
  "gamification:read",
  "golden-records:read",
  "golden-records:write",
  "governance:read",
  "heals:read",
  "heals:write",
  "initial-loads:read",
  "initial-loads:write",
  "intelligence:delete",
  "intelligence:read",
  "intelligence:write",
  "jobs:read",
  "jobs:write",
  "library:read",
  "library:write",
  "licence:write",
  "mappings:read",
  "mappings:write",
  "monitoring:read",
  "notifications:read",
  "notifications:write",
  "oauth:write",
  "onboarding:read",
  "onboarding:write",
  "operation-scopes:delete",
  "operation-scopes:read",
  "operation-scopes:write",
  "parallel-run-discrepancies:read",
  "pipeline-events:read",
  "pipeline-promotions:read",
  "pipeline-promotions:write",
  "pipeline-targets:delete",
  "pipeline-targets:read",
  "pipeline-targets:write",
  "pipelines:delete",
  "pipelines:read",
  "pipelines:write",
  "platform-config:read",
  "platform-config:write",
  "platform-value-scores:read",
  "platform-value-scores:write",
  "platform:read",
  "portal:read",
  "portal:write",
  "pricing:read",
  "quarantine:read",
  "restoration-requests:read",
  "restoration-requests:write",
  "retention-policies:delete",
  "retention-policies:read",
  "retention-policies:write",
  "retrieve:read",
  "schema:read",
  "search:read",
  "secrets:delete",
  "secrets:read",
  "secrets:write",
  "settings:delete",
  "settings:read",
  "settings:write",
  "support:read",
  "terms:read",
  "terms:write",
  "unified:delete",
  "unified:read",
  "unified:write",
  "webhooks:delete",
  "webhooks:read",
  "webhooks:write",
  "workflow-runs:read",
  "workflow-runs:write",
  "workflows:delete",
  "workflows:read",
  "workflows:write",
  "workspace-users:write",
  "workspace:delete",
  "workspace:read",
  "workspace:write",
  "workspaces:read"
] as const;
